
import axios from 'axios'
const base = window._env_.VUE_APP_HOST
export function getExel (url, params) {
  return new Promise(function (resolve, reject) {
    const data = {
      method: 'GET',
      url: base + url,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer',
      params: params
    }
    resolve(axios(data))
  })
}
export function getExelByPost (url, params) {
  return new Promise(function (resolve, reject) {
    const data = {
      method: 'post',
      url: base + url,
      data: params,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer'
    }
    resolve(axios(data))
  })
}

// 将字符串数组转换为数字数组
export function NumberArray (value) {
  const valueArray = Array.isArray(value) ? value : [value]
  return valueArray.map(item => Number(item))
}

export function StringArray (value) {
  // 如果 value 不是数组，则将其转换成数组
  const valueArray = Array.isArray(value) ? value : [value]
  return valueArray.map(item => String(item))
}



// WEBPACK FOOTER //
// ./core/utils/common.js